import type { PointerEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatherIcon } from '../components/FeatherIcon';
import { AiStatusBlock, FanIdentity, ListsBlock, NotesBlock, SpendingBlock } from './fanBlocks';
import { useSectionsOpen } from './sectionsOpen';
import type { FanData } from './useFan';

interface Props {
  accountId: string;
  fanId: string;
  fan: FanData;
  aiStatus?: string | null;
  /** Panel width in px (the host lets the person drag it). */
  width?: number;
  onResizeStart?: (e: PointerEvent) => void;
  resizing?: boolean;
  onHide?: () => void;
}

/** Workspace's Fan panel: the fixed set of fan blocks beside its chat (the Chats page arranges its own). */
export function FanPanel({ accountId, fanId, fan, aiStatus, width, onResizeStart, resizing, onHide }: Props) {
  const { t } = useTranslation('chat');
  const sections = useSectionsOpen();
  return (
    <aside className="rc-fan" style={width ? { width } : undefined}>
      {onResizeStart && <span className={`rc-fan-resize ${resizing ? 'is-active' : ''}`} onPointerDown={onResizeStart} title={t('fan.dragToResize')} />}
      <div className="rc-fan-scroll">
        <FanIdentity
          accountId={accountId}
          fanId={fanId}
          fan={fan}
          tools={
            onHide && (
              <button type="button" className="rc-icon-btn" title={t('fan.hidePanel')} onClick={onHide}>
                <FeatherIcon name="panel-right-close" size={14} />
              </button>
            )
          }
        />
        <SpendingBlock fan={fan} sections={sections} />
        <ListsBlock fan={fan} sections={sections} />
        <NotesBlock fan={fan} sections={sections} />
        <AiStatusBlock aiStatus={aiStatus} sections={sections} />
      </div>
    </aside>
  );
}
